var _path, _path2, _g, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemplatesBannerDarkLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 234,
    height: 141,
    viewBox: "0 0 234 141",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2708_27254)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2708_27254",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 234,
    height: 153,
    fill: "#ffffff"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H234V153H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2708_27254)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2708_27254",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 0,
    width: 143,
    height: 152,
    fill: "#ffffff"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 0H158V152H15V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2708_27254)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4479 111.363C63.575 115.248 56.6749 119.159 49.802 123.044C47.9819 121.795 46.1618 120.545 44.3688 119.295C47.7102 118.915 51.4863 118.263 55.5883 117.149C61.5375 115.519 66.5089 113.373 70.4479 111.363Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.0866 65.3442C79.2496 67.2458 79.6842 69.7179 80.7165 72.4616C82.1291 76.2377 84.1122 78.9814 85.5792 80.6928C83.2158 79.0086 80.8523 77.2971 78.4618 75.6129C78.6791 72.1628 78.8964 68.7399 79.0866 65.3442Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.1203 51.354C81.6401 62.7907 79.6027 76.4279 74.7672 88.0819C74.577 88.5709 73.7892 88.3536 73.9794 87.8646C78.7334 76.4279 80.8251 63.0352 74.414 51.7886C74.1695 51.2996 74.8758 50.8921 75.1203 51.354Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.4464 86.7508C74.8759 93.1347 75.0932 99.5186 76.1255 105.848C76.207 106.364 75.4192 106.582 75.3377 106.066C74.3054 99.6816 74.0609 93.2162 74.6314 86.7508C74.6857 86.2346 75.5007 86.2346 75.4464 86.7508Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.6909 106.527C67.7585 115.383 55.8328 118.154 44.5047 119.485C43.9886 119.54 43.9886 118.725 44.5047 118.67C55.6155 117.339 67.351 114.623 75.1204 105.957C75.4736 105.577 76.044 106.147 75.6909 106.527Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.3782 97.6714C64.5801 102.29 60.4238 105.957 55.4796 108.157C55.0178 108.375 54.5831 107.668 55.0721 107.451C59.9076 105.305 63.9281 101.773 66.6719 97.2639C66.9435 96.8021 67.6498 97.2096 67.3782 97.6714Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.7714 64.149C96.6627 71.4566 95.0599 78.6283 92.0717 85.3111C91.8544 85.8001 91.1481 85.3654 91.3654 84.9036C94.2993 78.3567 95.8477 71.3208 95.9564 64.1762C95.9564 63.6057 96.7714 63.6057 96.7714 64.149Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.7458 85.5555C87.2906 82.2684 82.8354 78.9542 78.3802 75.6672C77.9728 75.3684 78.3802 74.662 78.7877 74.9609C83.2429 78.2479 87.6981 81.5621 92.1532 84.8492C92.5607 85.1752 92.1532 85.8815 91.7458 85.5555Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.4183 64.5292C93.2127 61.0249 89.5725 57.9823 85.5248 55.5374C81.3685 53.011 76.5058 50.4574 71.5073 50.6748C70.9912 50.7019 70.9912 49.8869 71.5073 49.8598C76.5058 49.6696 81.3413 52.1145 85.5248 54.6138C89.7898 57.1402 93.6474 60.3186 96.9887 63.9859C97.3419 64.3391 96.7714 64.9096 96.4183 64.5292Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.6431 50.4032C71.5073 53.9075 69.2526 57.8194 65.232 57.1946C63.2761 56.8958 61.5647 55.619 60.0977 54.3422C58.6308 53.0654 57.4355 51.5713 56.8107 49.724C56.6477 49.235 57.4355 49.0177 57.5985 49.5067C58.5493 52.3319 61.293 54.8312 64.0096 55.9721C68.0029 57.6564 70.6923 54.0705 70.8282 50.4032C70.8553 49.887 71.6703 49.887 71.6431 50.4032Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.5288 49.7241C43.3637 51.0552 32.9593 56.7328 25.7332 65.3443C25.4072 65.7518 24.8096 65.1813 25.1627 64.7738C32.5246 55.9722 43.1464 50.2674 54.5288 48.9091C55.0449 48.8548 55.0449 49.6697 54.5288 49.7241Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.6789 65.2627C28.4498 67.4632 30.1613 70.6144 31.1392 73.9829C32.1172 77.3514 32.9321 81.4806 31.438 84.822C31.2207 85.311 30.5144 84.8763 30.7317 84.4145C32.1715 81.209 31.2207 77.0255 30.2156 73.8199C29.2648 70.723 27.6348 67.8978 25.0813 65.8604C24.6738 65.5072 25.2714 64.9367 25.6789 65.2627Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8747 76.3463C40.3211 78.7913 37.7676 81.2362 34.7793 83.1106C33.8285 83.7354 32.1443 85.0394 30.8946 84.7949C29.8624 84.6047 29.4549 83.4909 29.1832 82.5944C29.0202 82.0783 29.808 81.8881 29.971 82.3771C30.1883 83.1378 30.46 84.0886 31.4923 83.9527C32.0628 83.8712 32.8777 83.3008 33.3939 83.0019C34.4533 82.3771 35.4856 81.698 36.4636 80.9373C38.5282 79.3617 40.4298 77.5416 42.3042 75.7487C42.6845 75.4227 43.255 75.9932 42.8747 76.3463Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.1517 63.8773C96.9887 71.3207 95.3859 78.6011 92.452 85.4197C92.2347 85.9087 91.5556 85.474 91.7457 85.0122C94.6253 78.3295 96.1737 71.1577 96.3367 63.8773C96.3639 63.3612 97.1788 63.3612 97.1517 63.8773Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7333 64.7467C28.9388 66.4581 30.5144 69.9081 31.6554 73.2224C32.3345 75.2326 32.8507 77.3515 32.9322 79.4976C33.0137 81.1276 32.9322 82.8662 31.8184 84.1429C31.4652 84.5233 30.8947 83.9528 31.2479 83.5725C32.416 82.2685 32.2259 80.1224 32.0629 78.5197C31.8727 76.6181 31.3566 74.7708 30.7046 72.9779C29.6451 70.044 28.2053 67.0014 25.3258 65.4801C24.864 65.1813 25.2714 64.5022 25.7333 64.7467Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.9743 53.2012C73.0015 57.4663 68.8451 60.1557 64.9061 59.6123C60.1249 58.9604 57.0009 54.9942 54.8548 51.028C54.6103 50.5662 55.3166 50.1587 55.5611 50.6205C57.4084 54.0162 59.8804 57.4119 63.7651 58.5529C67.514 59.6395 72.2137 57.6021 72.1593 53.2012C72.1593 52.6851 72.9743 52.6851 72.9743 53.2012Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.4207 111.308C69.9045 111.308 69.9045 110.494 70.4207 110.494C70.9368 110.494 70.9368 111.308 70.4207 111.308Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2155 83.002C29.6722 92.2383 30.0797 101.529 31.4108 110.684C31.4923 111.2 30.7045 111.417 30.623 110.901C29.2919 101.665 28.8573 92.3198 29.4006 83.002C29.4277 82.4858 30.2427 82.4858 30.2155 83.002Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.6118 57.7651C50.6713 61.9486 50.0736 66.3223 47.8732 70.0711C47.6016 70.5329 46.8953 70.1255 47.1669 69.6636C49.2315 66.1321 49.8292 61.9758 48.824 58.0096C48.7154 57.4934 49.476 57.2761 49.6118 57.7651Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.8454 81.6709C31.4651 82.35 31.3293 83.0563 31.3836 83.8169H29.7537C29.7265 83.0563 29.808 82.3228 29.9982 81.5894C30.2427 80.5571 31.8183 80.9917 31.5738 82.024C31.438 82.6216 31.3836 83.2193 31.4108 83.8169C31.438 84.8764 29.8624 84.8492 29.7809 83.8169C29.6994 82.7846 29.9439 81.7524 30.46 80.8559C30.949 79.9323 32.3616 80.7472 31.8454 81.6709Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.1735 76.8897C39.4518 81.3448 36.1104 86.3977 30.786 89.0871C29.8623 89.5489 29.0202 88.1634 29.971 87.6744C35.1596 85.0394 38.4195 80.0681 42.0325 75.7216C42.6845 74.9338 43.8255 76.0747 43.1735 76.8897Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.316 80.8287C37.9306 82.024 36.4908 83.165 34.9967 84.2244C33.6384 85.1752 32.1986 85.8815 30.5415 85.4197C30.8947 85.1481 31.2207 84.9036 31.5738 84.6319C31.5738 85.3926 31.601 86.1532 31.601 86.9138C31.1935 86.6694 30.786 86.452 30.3785 86.2075C31.5467 85.5012 32.6876 84.7406 33.8014 83.8985C34.0731 84.3603 34.3447 84.8493 34.6164 85.3111C33.1494 86.0174 32.0085 86.9953 31.1392 88.3808C30.8132 88.8969 30.0526 88.9241 29.7266 88.3808C29.4549 87.8918 29.4006 87.5115 29.5092 86.9682C29.7266 85.9359 31.3022 86.3705 31.0849 87.4028C31.112 87.4572 31.112 87.5115 31.1392 87.5658H29.7266C30.7317 85.963 32.0628 84.7406 33.7743 83.8985C34.725 83.4366 35.4314 84.6863 34.5892 85.3111C33.5026 86.1532 32.3616 86.9138 31.1663 87.6202C30.623 87.9461 29.9439 87.5387 29.9439 86.9138C29.9439 86.1532 29.9167 85.3926 29.9167 84.6319C29.9167 84.1158 30.4329 83.7083 30.949 83.8441C32.4431 84.2788 33.8014 83.0835 34.9424 82.2413C36.0562 81.4264 37.1156 80.5571 38.1751 79.6606C38.9629 79.0086 40.1038 80.1496 39.316 80.8287Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.6305 70.3156H29.1018C28.5856 70.3156 28.5856 69.5006 29.1018 69.5006H95.6305C96.1466 69.5006 96.1466 70.3156 95.6305 70.3156Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.0923 68.1695H28.2325C27.8521 68.1695 27.825 67.5447 28.2325 67.5447H96.0923C96.4998 67.5447 96.4998 68.1695 96.0923 68.1695Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.9836 65.9963H26.684C26.3037 65.9963 26.2765 65.3715 26.684 65.3715H95.9836C96.3639 65.3715 96.3911 65.9963 95.9836 65.9963Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.0923 64.3119H26.7927C26.4124 64.3119 26.3852 63.6871 26.7927 63.6871H96.0923C96.4998 63.6871 96.4998 64.3119 96.0923 64.3119Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.408 62.2474H28.5041C28.1238 62.2474 28.0966 61.6226 28.5041 61.6226H94.408C94.8155 61.6497 94.8155 62.2474 94.408 62.2474Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.615 60.3187H31.0576C30.6773 60.3187 30.6502 59.6938 31.0576 59.6938H92.615C92.9953 59.721 92.9953 60.3187 92.615 60.3187Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.817 58.4985H69.7688C69.3884 58.4985 69.3613 57.8737 69.7688 57.8737H89.817C90.2245 57.9008 90.2245 58.4985 89.817 58.4985Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.1029 58.1453H32.9864C32.6061 58.1453 32.5789 57.5205 32.9864 57.5205H61.1029C61.4832 57.5477 61.4832 58.1453 61.1029 58.1453Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.4407 56.3253H35.9747C35.5943 56.3253 35.5672 55.7004 35.9747 55.7004H58.4407C58.821 55.7276 58.821 56.3253 58.4407 56.3253Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.7564 54.3965H39.968C39.5877 54.3965 39.5605 53.7717 39.968 53.7717H56.7564C57.1367 53.7989 57.1367 54.3965 56.7564 54.3965Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.6697 52.3591H44.2058C43.8255 52.3591 43.7983 51.7343 44.2058 51.7343H55.6697C56.05 51.7343 56.05 52.3591 55.6697 52.3591Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.6918 50.7835H49.6118C49.2315 50.7835 49.2044 50.1587 49.6118 50.1587H54.6918C55.0993 50.1587 55.0993 50.7835 54.6918 50.7835Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M79.4397 52.3591H72.6754C72.2951 52.3591 72.268 51.7343 72.6754 51.7343H79.4397C79.8472 51.7343 79.8472 52.3591 79.4397 52.3591Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M83.5417 54.7768H72.431C72.0507 54.7768 72.0235 54.152 72.431 54.152H83.5417C83.9492 54.152 83.9492 54.7768 83.5417 54.7768Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M86.9374 56.3253H72.2136C71.8333 56.3253 71.8061 55.7004 72.2136 55.7004H86.9374C87.3177 55.7276 87.3177 56.3253 86.9374 56.3253Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.386 72.027H78.8421C78.4618 72.027 78.4346 71.4022 78.8421 71.4022H95.386C95.7663 71.4294 95.7663 72.027 95.386 72.027Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M95.0056 74.0916H80.2818C79.9015 74.0916 79.8743 73.4668 80.2818 73.4668H95.0056C95.4131 73.4668 95.4131 74.0916 95.0056 74.0916Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.408 75.8846H81.4772C81.0968 75.8846 81.0697 75.2598 81.4772 75.2598H94.408C94.8155 75.2869 94.8155 75.8846 94.408 75.8846Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.0548 78.0578H82.4551C82.0748 78.0578 82.0476 77.433 82.4551 77.433H94.0548C94.4352 77.4601 94.4352 78.0578 94.0548 78.0578Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.5658 79.9865H84.9815C84.6012 79.9865 84.574 79.3617 84.9815 79.3617H93.5658C93.9733 79.3889 93.9733 79.9865 93.5658 79.9865Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.8324 81.698H87.5079C87.1276 81.698 87.1004 81.0732 87.5079 81.0732H92.8324C93.2399 81.0732 93.2399 81.698 92.8324 81.698Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M91.8816 83.9799H90.4418C90.0615 83.9799 90.0343 83.3551 90.4418 83.3551H91.8816C92.2619 83.3823 92.2619 83.9799 91.8816 83.9799Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.3531 72.2715H30.8947C30.5144 72.2715 30.4872 71.6467 30.8947 71.6467H78.3531C78.7606 71.6467 78.7606 72.2715 78.3531 72.2715Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.7554 74.3361H30.6773C30.297 74.3361 30.2698 73.7113 30.6773 73.7113H77.7554C78.1357 73.7113 78.1357 74.3361 77.7554 74.3361Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.7554 75.8846H31.764C31.3836 75.8846 31.3565 75.2598 31.764 75.2598H77.7554C78.1357 75.2869 78.1357 75.8846 77.7554 75.8846Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.4023 78.3023H32.4974C32.1171 78.3023 32.09 77.6775 32.4974 77.6775H77.4023C77.7826 77.7047 77.7826 78.3023 77.4023 78.3023Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.9133 80.231H32.3616C31.9813 80.231 31.9542 79.6062 32.3616 79.6062H76.9133C77.2936 79.6334 77.2936 80.231 76.9133 80.231Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.1798 82.1598H32.7148C32.3344 82.1598 32.3073 81.535 32.7148 81.535H76.1798C76.5873 81.5622 76.5873 82.1598 76.1798 82.1598Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.5822 83.9799H32.3616C31.9813 83.9799 31.9542 83.3551 32.3616 83.3551H75.5822C75.9625 83.3823 75.9625 83.9799 75.5822 83.9799Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.8487 85.9086H30.1884C29.808 85.9086 29.7809 85.2838 30.1884 85.2838H74.8487C75.2562 85.311 75.2562 85.9086 74.8487 85.9086Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.4955 87.9732H31.5195C31.1391 87.9732 31.112 87.3484 31.5195 87.3484H74.4955C74.8758 87.3484 74.8758 87.9732 74.4955 87.9732Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.74 89.7662H29.6994C29.319 89.7662 29.2919 89.1414 29.6994 89.1414H74.74C75.1203 89.1685 75.1203 89.7662 74.74 89.7662Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.4955 91.8307H30.1883C29.808 91.8307 29.7809 91.2059 30.1883 91.2059H74.4955C74.8758 91.2059 74.8758 91.8307 74.4955 91.8307Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.4955 93.7596H30.0797C29.6994 93.7596 29.6722 93.1348 30.0797 93.1348H74.4955C74.8758 93.1619 74.8758 93.7596 74.4955 93.7596Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.3869 95.5796H30.1884C29.808 95.5796 29.7809 94.9548 30.1884 94.9548H74.3869C74.7672 94.9548 74.7672 95.5796 74.3869 95.5796Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.6042 97.6171H29.6994C29.3191 97.6171 29.2919 96.9923 29.6994 96.9923H74.6042C75.0117 97.0195 75.0117 97.6171 74.6042 97.6171Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.74 99.7903H30.1884C29.808 99.7903 29.7809 99.1655 30.1884 99.1655H74.74C75.1203 99.1927 75.1203 99.7903 74.74 99.7903Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.8487 101.964H30.297C29.9167 101.964 29.8895 101.339 30.297 101.339H74.8487C75.2562 101.366 75.2562 101.964 74.8487 101.964Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.0932 103.784H30.6773C30.297 103.784 30.2699 103.159 30.6773 103.159H75.0932C75.5007 103.159 75.5007 103.784 75.0932 103.784Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.229 105.604H30.6774C30.2971 105.604 30.2699 104.979 30.6774 104.979H75.229C75.6094 104.979 75.6094 105.604 75.229 105.604Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.251 107.777H30.9218C30.5415 107.777 30.5143 107.152 30.9218 107.152H74.251C74.6585 107.152 74.6585 107.777 74.251 107.777Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.7246 109.461H30.786C30.4057 109.461 30.3785 108.836 30.786 108.836H71.7246C72.105 108.836 72.105 109.461 71.7246 109.461Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.1711 111.39H31.9813C31.601 111.39 31.5738 110.765 31.9813 110.765H69.1711C69.5786 110.765 69.5786 111.39 69.1711 111.39Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.9112 113.427H34.6435C34.2632 113.427 34.236 112.803 34.6435 112.803H65.9112C66.3187 112.83 66.3187 113.427 65.9112 113.427Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M62.0537 115.383H37.5503C37.17 115.383 37.1428 114.759 37.5503 114.759H62.0537C62.4612 114.759 62.4612 115.383 62.0537 115.383Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.2894 117.421H40.9188C40.5385 117.421 40.5113 116.796 40.9188 116.796H55.2894C55.6969 116.823 55.6969 117.421 55.2894 117.421Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.9072 66.9199C96.6899 70.4515 96.4182 74.0373 96.0923 77.6775C95.9564 79.1716 95.8206 80.6657 95.6848 82.1327C95.0056 81.5622 94.3265 80.9917 93.6473 80.3941C94.734 75.9118 95.8206 71.4023 96.9072 66.9199Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.83 63.986C132.277 70.7231 125.132 74.5534 118.151 74.6893C109.675 74.8251 102.042 69.7723 96.3096 63.9588C95.9292 63.5785 96.5269 63.008 96.88 63.3884C102.313 68.8758 109.431 73.6841 117.417 73.8743C124.263 74.0101 131.543 70.3971 134.07 63.7687C134.233 63.2797 135.021 63.497 134.83 63.986Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.432 69.9352C133.961 82.2956 119.455 89.5488 105.084 86.2618C100.955 85.311 97.0702 83.5181 93.6745 80.9916C93.267 80.6928 93.6745 79.9865 94.082 80.2853C101.498 85.8543 111.359 87.6201 120.297 85.2295C128.854 82.9204 136.162 77.0798 140.698 69.5277C140.997 69.0659 141.703 69.4734 141.432 69.9352Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.296 60.21C141.975 58.9603 142.029 57.4934 141.405 56.1894C141.187 55.7276 141.894 55.293 142.111 55.782C142.872 57.3576 142.817 59.0962 142.002 60.6174C141.758 61.0793 141.051 60.6718 141.296 60.21Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.812 54.6954C142.437 53.8532 142.899 52.9568 143.17 51.9245C143.415 51.0552 143.741 49.4524 143.36 48.5288C143.388 48.0941 143.17 47.904 142.654 47.9855C142.301 47.6866 142.084 47.6595 142.002 47.904C141.948 47.9311 141.785 48.3386 141.758 48.393C141.459 49.0178 141.133 49.6426 140.807 50.2402C140.155 51.3812 139.503 52.2776 138.443 53.0383C136.868 54.2064 136.297 56.1352 136.08 58.0096C136.026 58.5257 135.211 58.5257 135.265 58.0096C135.51 55.9993 136.107 53.8533 137.764 52.5493C138.715 51.7887 139.394 51.0824 140.019 49.9957C140.481 49.1808 140.834 48.3115 141.296 47.4965C142.111 46.111 143.632 46.3555 144.067 47.9311C144.773 50.3489 143.931 53.1469 142.518 55.1029C142.192 55.5375 141.486 55.13 141.812 54.6954Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.943 69.6908C142.654 67.8435 144.23 65.8604 145.642 63.7687C146.974 61.7856 148.305 59.6395 148.468 57.1946C148.658 54.2607 147.272 51.1366 148.603 48.3114C149.907 45.5134 152.57 44.2909 155.531 44.5897C155.639 44.6169 155.775 44.6712 155.884 44.7256C156.916 44.0736 157.106 43.6389 156.427 43.3673C156.101 43.0956 155.558 42.9869 155.15 42.9326C154.2 42.7696 153.194 42.8783 152.244 43.0413C150.695 43.3129 149.174 43.8019 147.707 44.3724C147.218 44.5626 147.001 43.7748 147.49 43.5846C149.935 42.661 152.896 41.6287 155.531 42.172C156.4 42.3621 157.758 42.8783 157.976 43.8563C158.193 44.9157 156.971 45.6763 156.047 45.5949C155.232 45.5134 154.634 45.2145 153.765 45.3504C152.76 45.5134 151.755 45.9208 150.94 46.5728C150.152 47.2248 149.527 48.1484 149.147 49.0992C147.952 52.3048 149.907 55.8906 148.957 59.2048C148.359 61.2423 147.137 63.0895 145.941 64.8281C144.61 66.7569 143.116 68.6042 141.513 70.3156C141.16 70.6688 140.59 70.0711 140.943 69.6908Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.133 45.4047C140.481 42.0904 141.812 39.0751 143.007 36.0597C143.686 34.3754 144.366 32.6096 144.556 30.7895C144.664 29.7029 144.474 25.9269 142.355 28.1001C141.731 28.7521 141.35 29.8659 140.97 30.6537C137.303 38.8306 135.347 47.8224 134.803 56.7327C134.776 57.2489 133.961 57.2489 133.988 56.7327C134.314 51.5169 135.102 46.3555 136.433 41.3298C137.112 38.7491 137.927 36.1955 138.878 33.6963C139.666 31.6317 140.427 29.3226 141.758 27.5297C142.545 26.4702 143.904 26.28 144.8 27.3938C145.86 28.7249 145.452 30.9254 145.099 32.4195C144.121 36.6302 141.024 40.6235 141.921 45.133C142.029 45.7035 141.242 45.9208 141.133 45.4047Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.692 34.4569C146.512 32.9085 148.631 31.6045 151.076 31.4415C152.841 31.3329 154.607 32.0392 153.52 34.0223C152.379 36.1412 149.853 37.2278 148.114 38.8034C145.968 40.7865 144.284 43.2042 143.17 45.9208C142.98 46.4098 142.192 46.1925 142.383 45.7035C143.822 42.2263 146.077 39.2109 149.092 36.9561C149.799 36.4128 155.042 32.6911 152.026 32.2837C149.527 31.9305 147.055 33.5333 145.262 35.0545C144.855 35.3805 144.284 34.8101 144.692 34.4569Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M151.863 35.5435C153.004 35.5164 154.58 35.8695 155.069 37.0648C155.476 38.07 154.689 39.0208 153.955 39.6184C151.103 41.9003 147.49 43.1228 145.778 46.5728C145.534 47.0346 144.855 46.6271 145.072 46.1653C145.996 44.2909 147.49 42.9326 149.174 41.7645C150.261 41.031 151.402 40.379 152.488 39.6456C153.031 39.2652 154.227 38.6133 154.335 37.8526C154.498 36.5215 152.651 36.3042 151.863 36.3314C151.347 36.3585 151.347 35.5435 151.863 35.5435Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M134.803 55.7548C135.292 58.5257 135.238 61.2966 134.613 64.0675C134.504 64.5837 133.717 64.3664 133.825 63.8502C134.423 61.2423 134.504 58.6072 134.015 55.9722C133.907 55.456 134.695 55.2387 134.803 55.7548Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.3344 80.9373C27.5533 84.6318 24.6466 90.5268 24.8367 96.6119C25.0269 102.643 28.3139 108.32 33.2852 111.689C33.7199 111.988 33.3124 112.694 32.8778 112.395C27.7706 108.945 24.4021 103.213 24.0489 97.0194C23.6958 90.6083 26.7112 84.2787 31.764 80.3668C32.1443 80.068 32.7419 80.6385 32.3344 80.9373Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0372 66.8112C19.9198 72.5704 15.9536 81.5079 15.7363 90.5812C15.4918 100.415 19.5123 109.95 25.7061 117.475C26.0321 117.883 25.4616 118.453 25.1356 118.046C15.4918 106.31 11.4713 89.7934 18.6973 75.8303C20.5989 72.1357 23.234 68.8487 26.4667 66.2408C26.8742 65.9148 27.4447 66.4853 27.0372 66.8112Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.9865 111.743C38.7727 115.519 44.6134 119.268 50.3453 123.126C50.9701 123.533 51.7579 123.995 51.7579 124.837C51.7308 125.516 51.1331 125.978 50.5626 126.223C49.476 126.684 48.1177 126.684 47.0039 126.44C45.863 126.195 42.5216 123.886 41.924 125.571C41.761 126.06 40.9732 125.842 41.1362 125.353C41.7338 123.642 43.5539 123.995 44.8579 124.674C46.2976 125.435 47.6016 125.951 49.2587 125.734C49.5303 125.706 50.3996 125.625 50.5898 125.353C50.9158 124.81 50.3182 124.158 49.9922 123.859C49.4489 123.343 48.6339 122.963 48.0091 122.555C42.9019 119.187 37.7676 115.845 32.6333 112.477C32.1172 112.178 32.5246 111.472 32.9865 111.743Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.8419 117.475C26.195 120.355 25.5702 123.18 25.1627 126.032C24.6466 129.482 24.9182 132.661 26.3852 135.866C27.6348 138.583 29.3462 141.055 31.0577 143.473C31.9541 144.749 32.8778 146.026 33.8286 147.276C34.8337 148.634 35.8388 150.237 37.4688 150.889C37.9577 151.079 37.7404 151.867 37.2514 151.677C34.6979 150.672 33.0951 147.71 31.5738 145.592C29.5364 142.766 27.4175 139.86 25.8962 136.681C24.5379 133.883 23.8859 130.949 24.1576 127.852C24.4564 124.375 25.5159 120.979 25.0812 117.475C24.9726 116.959 25.7875 116.959 25.8419 117.475Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.8153 125.516C42.7932 129.7 44.9393 133.421 47.3299 136.953C48.498 138.692 49.7476 140.403 50.9429 142.142C51.8394 143.446 53.7138 145.429 53.6323 147.113C53.578 148.363 52.5457 149.042 51.3776 148.607C49.5846 147.901 48.0634 145.809 46.8137 144.451C43.6082 141.001 40.5656 137.388 37.6861 133.639C37.3601 133.231 38.0664 132.824 38.3924 133.231C40.8645 136.437 43.4724 139.561 46.1889 142.549C47.4657 143.962 48.7425 145.429 50.1551 146.733C50.4268 146.977 50.9429 147.629 51.3504 147.683C53.7138 147.928 52.6272 146.216 52.2197 145.564C51.7579 144.804 51.2417 144.043 50.7528 143.31C47.0039 137.768 42.6031 132.416 41.0275 125.761C40.8916 125.217 41.6794 125 41.8153 125.516Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.2587 147.384C46.2976 147.439 43.907 145.782 41.8153 143.853C39.2617 141.517 36.7353 139.099 34.2089 136.736C33.8286 136.382 34.3991 135.812 34.7794 136.165C36.9526 138.203 39.1531 140.267 41.3263 142.305C43.5539 144.396 45.9716 146.624 49.2315 146.57C49.7748 146.542 49.7748 147.357 49.2587 147.384Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.2925 146.95C43.0106 148.2 40.7558 146.896 38.8271 145.592C36.4365 143.989 34.2089 142.169 32.1172 140.159C31.7368 139.805 32.3073 139.208 32.6876 139.588C34.3447 141.218 36.1377 142.712 38.0121 144.07C39.8865 145.429 42.4673 147.575 44.8579 146.271C45.3197 145.999 45.7543 146.705 45.2925 146.95Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.5789 139.778C33.7471 142.902 36.0833 145.32 37.7676 148.145C38.2566 148.933 39.316 150.4 38.9085 151.405C38.5554 152.329 37.5503 152.003 36.9526 151.595C36.518 151.296 36.9255 150.59 37.3601 150.889C38.2022 150.97 38.3924 150.699 37.8762 150.074C37.7676 149.802 37.6318 149.558 37.4959 149.313C37.2243 148.797 36.9254 148.308 36.5995 147.819C36.0561 146.977 35.4313 146.135 34.8337 145.32C33.6384 143.636 32.4974 141.951 31.764 139.996C31.6281 139.507 32.416 139.289 32.5789 139.778Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.9091 34.1581C56.1859 34.0494 56.9465 34.4569 57.2997 34.7014C57.5713 34.8915 58.0331 35.2719 59.1469 38.1514C59.9619 40.2432 59.9347 40.6235 59.7989 40.9223C59.4458 41.8459 58.2776 42.4979 57.2725 42.3893C56.3489 42.2806 56.2131 41.5471 54.7461 40.1345C53.6052 39.0207 52.4914 38.3144 50.5083 37.0919C49.0956 36.2226 48.0634 35.6793 48.1177 35.4892C48.2264 35.2719 50.1551 36.4128 52.2197 35.8967C53.4422 35.5978 54.3115 34.8644 54.9091 34.1581Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.4294 23.4277C77.6196 23.5363 77.9999 23.7808 78.7062 25.6824C79.0594 26.6604 79.2767 27.4753 79.4397 28.0458C79.331 28.2903 79.1137 28.6706 78.7062 28.9423C78.2172 29.2954 77.7826 29.3226 76.533 29.4856C76.1526 29.5399 75.555 29.6214 74.8215 29.7573C74.8487 27.7742 74.8759 25.7639 74.903 23.7808C75.229 23.5907 76.4786 22.9115 77.4294 23.4277Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.2378 12.0996C82.7539 10.6599 82.4279 9.05709 81.3685 7.97046C79.8472 6.42202 77.7283 6.88383 77.6468 6.911C77.5925 6.69367 77.1578 5.14523 75.5279 4.41176C73.7893 3.65112 72.2408 4.52042 72.0778 4.60192C72.1865 4.27593 72.757 2.12984 71.5889 0.880224C70.2577 -0.586722 67.4868 0.0924196 66.1286 0.690064C64.2541 1.5322 64.3628 2.51016 62.8687 2.89048C60.7226 3.4338 59.8805 1.50503 57.517 1.64086C55.8056 1.74952 54.5017 2.97198 51.8666 5.47122C49.639 7.56297 49.8563 7.94329 47.7374 9.87206C44.9393 12.4528 44.3145 12.0181 43.1464 13.7024C43.0378 13.8654 40.9188 17.0166 41.7066 20.6025C42.1141 22.5041 42.8748 22.3683 43.3366 24.4328C43.9071 27.0679 42.8476 28.073 43.4452 30.0833C43.7441 31.0884 44.4775 32.4739 46.5965 33.805C46.7323 32.1751 46.8409 30.5451 46.9768 28.9152C46.6236 28.6707 46.4606 28.4262 46.4063 28.236C46.189 27.6656 46.515 27.0951 47.5473 25.275C48.0906 24.3242 48.3622 23.8624 48.4165 23.7537C48.9599 22.6128 49.1772 21.5533 49.2859 20.7927C49.313 19.7875 49.4488 18.3206 49.8563 16.582C50.1823 15.2237 50.454 14.0556 51.106 13.0504C52.0296 11.6107 53.5509 10.7685 56.9466 9.79056C60.4781 8.78543 63.1403 8.02479 67.1065 8.07912C73.9251 8.13345 79.2496 10.4969 82.2378 12.0996Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.1173 27.3395C85.2532 32.664 83.9221 38.4774 79.8744 42.2534C76.3157 45.5405 70.9369 46.8716 66.4817 44.644C66.0199 44.3995 66.4274 43.6932 66.8892 43.9377C71.2357 46.111 76.6145 44.5354 79.8472 41.1125C83.2972 37.4451 84.411 32.2293 84.3024 27.3395C84.2752 26.8234 85.0902 26.8234 85.1173 27.3395Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.6211 45.9208C72.1321 47.5236 71.616 49.1264 71.127 50.7291C70.964 51.2181 70.1762 51.028 70.3392 50.5118C70.8282 48.909 71.3443 47.3063 71.8333 45.7035C71.9963 45.2145 72.7841 45.4318 72.6211 45.9208Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.2828 41.031C59.3371 43.8291 58.7395 46.5185 57.517 49.0449C57.3812 49.2894 57.0552 49.2894 56.8651 49.1264C56.1859 48.5559 55.2623 48.8276 54.882 49.5339C54.6375 49.9957 53.9312 49.5882 54.1757 49.1264C54.8548 47.9039 56.3761 47.6595 57.4355 48.5288C57.2182 48.5559 57.0009 48.5831 56.7836 48.6103C57.9517 46.2197 58.495 43.6933 58.4407 41.031C58.4407 40.5149 59.2556 40.5149 59.2828 41.031Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3986 47.8496C69.497 47.1161 67.8128 46.0567 66.3458 44.6712C65.9655 44.3181 66.536 43.7204 66.9163 44.1008C68.2746 45.4047 69.8502 46.4098 71.5888 47.089C72.1049 47.252 71.8876 48.0398 71.3986 47.8496Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.2137 46.3284C71.7518 46.5457 71.3444 46.5185 70.8554 46.4099C70.1491 46.2469 69.4699 46.0567 68.7636 45.8937L69.0896 45.1602C69.9317 45.622 70.7739 46.0295 71.6703 46.3555C72.1593 46.5457 71.942 47.3335 71.453 47.1433C70.5022 46.7902 69.5514 46.3555 68.655 45.8665C68.2475 45.6492 68.5191 45.0244 68.9809 45.1331C69.4428 45.2417 69.9046 45.3504 70.3664 45.4862C70.7739 45.5949 71.3987 45.8665 71.8062 45.6764C72.268 45.4047 72.6755 46.111 72.2137 46.3284Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7748 28.1273C48.1448 27.6655 47.357 29.6758 47.1397 30.8439C46.9224 32.0664 47.1669 33.3432 47.9275 34.3483C48.6338 35.2447 49.639 35.7609 50.7799 35.7609C51.9209 35.7609 53.6323 35.2719 53.9583 34.0766C54.0941 33.5605 54.8819 33.7778 54.7461 34.294C54.3658 35.7337 52.8173 36.3042 51.4591 36.5215C49.7476 36.7932 48.1177 36.0869 47.1126 34.6743C45.5913 32.5553 46.1889 26.2801 49.9649 27.3667C50.4811 27.4754 50.2909 28.2632 49.7748 28.1273Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.2535 30.0833C49.7748 28.8337 52.1654 30.6538 52.5729 32.2294C52.7087 32.7455 51.9209 32.9629 51.7851 32.4467C51.5678 31.5774 49.8563 29.8116 48.824 30.6538C48.4165 30.9798 47.8461 30.4093 48.2535 30.0833Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.5949 32.2837C51.3776 31.8491 50.78 31.7676 50.617 32.3109C50.4811 32.827 50.943 33.2073 51.3233 33.4247C51.7851 33.6692 51.3776 34.3755 50.9158 34.131C50.0737 33.6692 49.3673 32.5554 50.0465 31.6589C50.6441 30.8711 51.8666 31.0341 52.3012 31.9034C52.5457 32.338 51.8394 32.7455 51.5949 32.2837Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.0086 26.9592C85.7693 26.8506 86.4213 26.6332 87.0732 26.2529C87.0461 26.3887 86.9917 26.5246 86.9646 26.6604C83.3515 21.9064 77.3479 19.8961 71.5345 20.032C68.3289 20.1135 65.1777 20.7655 62.1352 21.7162C59.0926 22.667 55.9957 23.7537 53.6051 25.9269C53.3063 26.1986 52.8717 25.7639 53.1705 25.4923C55.5339 23.3734 58.495 22.2324 61.4832 21.2816C64.8789 20.195 68.4376 19.4343 72.0235 19.4343C77.8912 19.4072 83.8405 21.5804 87.4807 26.3616C87.5894 26.4974 87.5079 26.7147 87.3721 26.7691C86.6386 27.1765 85.9594 27.3939 85.1445 27.5297C84.7913 27.6112 84.6012 27.0136 85.0086 26.9592Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.4925 27.2852C82.8082 25.9813 80.9066 25.0305 78.8149 24.4872C78.4346 24.3785 78.5975 23.808 78.9779 23.8895C81.1511 24.46 83.1342 25.4651 84.9271 26.8506C85.2531 27.0951 84.8185 27.5297 84.4925 27.2852Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.4074 24.2698C77.4566 22.993 75.6909 23.0474 74.7401 24.2698C74.4956 24.5686 74.0609 24.134 74.3054 23.8352C75.555 22.2596 77.7826 22.3954 78.9507 23.9438C79.1681 24.2698 78.6519 24.5958 78.4074 24.2698Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M74.577 24.1339C67.8128 22.6127 61.4289 25.7367 55.5883 28.7521C55.2351 28.9423 54.9363 28.399 55.2894 28.236C61.293 25.1391 67.8128 21.9879 74.7672 23.5635C75.1475 23.645 74.9845 24.2426 74.577 24.1339Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.4808 25.9541C87.5351 20.5209 85.3075 15.3595 81.3413 11.6649C81.0425 11.3933 81.4771 10.9586 81.776 11.2303C85.878 15.0063 88.1599 20.3851 88.1056 25.9541C88.0784 26.3344 87.4536 26.3344 87.4808 25.9541Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.9118 12.2897C78.7062 9.62746 74.5771 8.73099 70.5022 8.62233C66.4545 8.51366 62.271 8.78532 58.3592 9.79045C56.5662 10.2523 54.6646 10.8227 53.1162 11.9094C51.1874 13.2405 50.7528 15.3322 50.291 17.4783C50.0736 18.4291 49.8291 19.4071 49.639 20.3579C49.476 21.2 49.5575 22.0693 49.3673 22.8843C49.2043 23.6178 48.7425 24.2154 48.335 24.8402C47.9004 25.5737 46.5693 27.4753 46.9767 28.2903C47.1669 28.6434 46.6236 28.9422 46.4606 28.5891C45.7543 27.2308 47.5472 25.0304 48.1992 23.9166C48.824 22.83 48.7697 21.9063 48.9327 20.711C49.1228 19.5701 49.4216 18.4291 49.6661 17.3153C50.128 15.3322 50.5083 13.322 52.0839 11.9365C53.4422 10.7412 55.2623 10.0893 56.9737 9.57312C61.3474 8.24201 66.1557 7.88885 70.6924 8.05185C74.8759 8.21484 79.0051 9.19281 82.2921 11.8822C82.6453 12.0995 82.2106 12.5342 81.9118 12.2897Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.7784 28.7522C51.9209 29.7573 51.3232 24.4057 49.3402 22.5041C49.0685 22.2324 49.476 21.7977 49.7748 22.0694C51.5677 23.7808 52.3012 29.0238 55.6154 28.1545C55.9957 28.073 56.1587 28.6707 55.7784 28.7522Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6764 25.7096C51.1874 26.4159 50.6984 27.1222 50.1823 27.8285C49.9649 28.1545 49.4216 27.8557 49.6661 27.5297C50.1551 26.8234 50.6441 26.1171 51.1602 25.4108C51.3776 25.0848 51.9209 25.3836 51.6764 25.7096Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.0543 23.3733C78.5432 24.4056 79.0322 25.4379 79.4397 26.4974C79.657 27.0407 80.2818 27.9915 79.9559 28.5891C79.7114 29.0509 78.9236 29.2139 78.4889 29.3498C77.3208 29.7301 76.1255 30.0017 74.9302 30.1919C74.5499 30.2462 74.3869 29.6758 74.7672 29.5943C75.881 29.4041 78.3531 29.2411 79.0594 28.2903C79.4125 27.8285 79.3039 27.8285 79.0866 27.3123C78.9507 26.932 78.7877 26.5789 78.6519 26.1986C78.2988 25.3293 77.9184 24.4871 77.5109 23.645C77.348 23.319 77.8641 23.0202 78.0543 23.3733Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.1475 24.134C75.1204 25.9813 75.1204 27.8285 75.0932 29.6758C75.0932 30.0561 74.4684 30.0833 74.4684 29.6758C74.4955 27.8285 74.4955 25.9813 74.5227 24.134C74.5227 23.7537 75.1475 23.7537 75.1475 24.134Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.0102 20.7654C75.7995 16.5004 70.964 12.9146 65.6395 10.1165C65.2864 9.92633 65.6124 9.41018 65.9384 9.60034C71.29 12.4256 76.1798 16.0386 80.4177 20.3308C80.7165 20.6296 80.309 21.0371 80.0102 20.7654Z",
    fill: "#dddddd"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.1388 16.5004C64.9604 13.7838 61.4289 11.5834 57.6257 9.84481C57.2725 9.68182 57.5714 9.16567 57.9245 9.32866C61.782 11.0673 65.3407 13.3492 68.5463 16.0657C68.8723 16.3374 68.4376 16.7721 68.1388 16.5004Z",
    fill: "#dddddd"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.318 119.612C153.153 126.546 135.442 113.719 121.029 124.034C119.594 125.061 118.303 126.252 117.134 127.576C115.688 129.226 114.46 131.108 112.716 132.485C111.004 133.838 108.489 134.697 106.45 133.586C104.727 132.637 104.087 130.55 103.717 128.732C103.186 126.123 103.32 121.969 99.7489 121.785C96.2925 121.589 94.6217 125.05 93.31 127.658C92.2184 129.76 91.0986 132.227 89.4177 133.926C88.2424 135.107 86.2796 135.881 84.8886 134.615C84.1209 133.9 83.9608 132.739 83.8026 131.749C83.2202 128.194 81.4482 125.364 77.8312 124.377C77.3138 124.24 77.1848 125.072 77.7021 125.209C79.7395 125.78 81.4731 127.213 82.3327 129.164C83.0034 130.688 82.8517 132.397 83.467 133.912C84.7124 137.03 88.3256 136.397 90.2648 134.313C91.5619 132.895 92.4997 131.053 93.416 129.35C94.4412 127.492 95.2092 125.283 96.8003 123.798C97.662 122.994 98.8448 122.496 100.039 122.653C101.645 122.902 102.177 124.404 102.414 125.804C102.684 127.351 102.839 128.908 103.316 130.402C104.172 133.289 106.433 135.344 109.601 134.841C113.499 134.196 115.611 130.634 117.99 127.907C120.779 124.734 124.475 122.467 128.553 121.396C132.925 120.257 137.487 120.453 141.946 120.946C150.777 121.946 160.175 124.227 168.657 120.346C169.135 120.193 168.831 119.408 168.318 119.612Z",
    fill: "#FF4F79"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.166 22.0144C189.035 27.5423 189.455 33.1263 189.427 38.7383C189.427 39.2715 188.587 39.2715 188.587 38.7383C188.615 33.2105 188.222 27.7107 187.354 22.2389C187.27 21.7058 188.082 21.4813 188.166 22.0144Z",
    fill: "#dddddd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M188.895 39.075C187.718 39.8607 186.318 39.6643 184.945 39.6082C182.9 39.524 180.883 39.4679 178.838 39.4398C174.776 39.3556 170.687 39.3837 166.625 39.4398C166.093 39.4398 166.093 38.598 166.625 38.598C170.323 38.5138 174.02 38.5138 177.746 38.5699C179.511 38.598 181.275 38.6261 183.012 38.6822C184.637 38.7383 187.046 39.2714 188.474 38.3174C188.923 38.0368 189.343 38.7664 188.895 39.075Z",
    fill: "#dddddd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.662 22.6598C179.118 21.6496 170.519 21.6777 162.003 22.7439C161.471 22.8001 161.471 21.9583 162.003 21.9021C170.519 20.8359 179.146 20.8078 187.662 21.818C188.194 21.9021 188.194 22.7439 187.662 22.6598Z",
    fill: "#dddddd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.465 39.6362C166.485 39.5801 165.532 39.4959 164.552 39.4398C164.02 39.4117 163.348 39.4117 162.871 39.075C161.919 38.4016 162.031 36.5496 161.919 35.5394C161.443 31.2743 161.191 27.0091 161.107 22.7159C161.107 22.1828 161.947 22.1828 161.947 22.7159C162.003 25.9148 162.143 29.0856 162.423 32.2564C162.563 33.7997 162.703 35.343 162.899 36.8863C163.067 38.121 163.88 38.5138 165.028 38.598C165.841 38.6541 166.653 38.7102 167.437 38.7663C168.026 38.8505 168.026 39.6923 167.465 39.6362Z",
    fill: "#dddddd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.841 25.5499C183.684 27.0652 181.696 28.7207 179.847 30.6008C178.866 31.6109 177.578 33.7154 175.897 33.4068C174.945 33.2384 174.076 32.3685 173.32 31.8354C172.48 31.2461 171.695 30.6288 170.883 29.9834C168.978 28.4401 167.157 26.7565 165.476 24.9887C165.112 24.5959 165.701 24.0066 166.065 24.3995C167.437 25.8305 168.838 27.1774 170.351 28.4682C171.191 29.1977 172.059 29.8993 172.956 30.5446C173.908 31.2742 174.889 32.1721 176.093 32.3405C176.99 32.4527 177.186 32.2282 177.774 31.6109C178.11 31.2742 178.418 30.9094 178.754 30.5446C179.427 29.8151 180.155 29.1136 180.883 28.4401C182.312 27.1213 183.852 25.9147 185.449 24.8204C185.869 24.5117 186.29 25.2413 185.841 25.5499Z",
    fill: "#dddddd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.184 45.6121C172.808 49.5966 175.834 52.8516 178.747 55.9383C181.464 58.8004 184.265 61.5503 186.814 64.5527C191.997 70.754 194.854 78.3303 195.778 86.3555C196.255 90.5084 195.89 94.7455 193.565 98.3092C193.257 98.7581 192.529 98.3372 192.837 97.8883C195.722 93.4548 195.414 88.0391 194.406 83.0725C193.313 77.8252 191.661 72.7183 188.607 68.2847C185.806 64.216 182.192 60.7646 178.803 57.201C175.553 53.8057 172.192 50.242 170.399 45.8366C170.175 45.3315 170.987 45.107 171.184 45.6121Z",
    fill: "#FF4F79"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M199.705 111.538C196.904 108.732 194.131 105.898 191.33 103.092C190.938 102.699 191.554 102.11 191.918 102.503C194.719 105.309 197.492 108.143 200.294 110.949C200.658 111.342 200.07 111.931 199.705 111.538Z",
    fill: "#dddddd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M191.778 103.204C186.652 103.541 181.553 104.214 176.511 105.281C175.979 105.393 175.755 104.579 176.287 104.467C181.385 103.401 186.568 102.699 191.778 102.362C192.31 102.306 192.31 103.148 191.778 103.204Z",
    fill: "#dddddd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.294 112.099C194.775 112.997 189.257 113.895 183.71 114.793C183.178 114.877 182.954 114.063 183.486 113.979C189.005 113.081 194.523 112.183 200.069 111.285C200.574 111.201 200.826 112.015 200.294 112.099Z",
    fill: "#dddddd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M182.982 114.035C180.713 111.089 178.472 108.171 176.203 105.224C175.867 104.803 176.595 104.383 176.931 104.803C179.2 107.75 181.441 110.668 183.71 113.614C184.047 114.035 183.318 114.456 182.982 114.035Z",
    fill: "#dddddd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M183.738 114.316C183.038 118.469 182.338 122.594 181.638 126.747C181.554 127.28 180.741 127.055 180.825 126.522C181.526 122.369 182.226 118.244 182.926 114.091C183.01 113.558 183.823 113.783 183.738 114.316Z",
    fill: "#dddddd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M180.629 127.196C178.836 123.379 176.819 119.704 174.522 116.168C174.214 115.719 174.943 115.298 175.251 115.747C177.548 119.283 179.593 122.959 181.357 126.775C181.582 127.252 180.853 127.701 180.629 127.196Z",
    fill: "#dddddd"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M176.988 105.477C176.315 108.984 175.699 112.492 175.139 116C175.055 116.533 174.242 116.308 174.326 115.775C174.859 112.239 175.475 108.732 176.175 105.252C176.287 104.719 177.072 104.944 176.988 105.477Z",
    fill: "#dddddd"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M200.602 111.762C199.537 115.943 198.613 120.181 197.857 124.446C197.773 124.979 196.96 124.754 197.044 124.221C197.801 119.956 198.725 115.747 199.789 111.538C199.929 111.005 200.742 111.229 200.602 111.762Z",
    fill: "#dddddd"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M197.576 125.035C192.282 126.663 186.792 127.448 181.245 127.364C180.713 127.364 180.713 126.522 181.245 126.522C186.708 126.606 192.114 125.849 197.352 124.221C197.885 124.053 198.109 124.867 197.576 125.035Z",
    fill: "#dddddd"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M160.226 16.7247C153.969 11.9391 146.183 8.3119 138.138 8.77556C133.497 9.06137 129.199 10.8706 125.295 13.2946C121.053 15.9172 117.224 19.2415 114.139 23.1695C110.768 27.494 108.474 32.8777 103.776 35.9961C103.332 36.2899 103.758 37.0157 104.203 36.7219C107.76 34.3714 109.987 30.7523 112.26 27.2683C115.025 23.0725 118.314 19.3822 122.338 16.334C126.184 13.4237 130.617 10.851 135.417 9.95107C139.384 9.18236 143.485 9.63676 147.321 10.8004C151.785 12.1483 155.928 14.4982 159.639 17.3297C160.064 17.6658 160.651 17.0608 160.226 16.7247Z",
    fill: "#FF4F79"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2708_27254",
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 234,
    height: 153,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplatesBannerDarkLeft);
export default __webpack_public_path__ + "static/media/templatesBannerDarkLeft.9cc965310a013badc12fcf7f64169ba1.svg";
export { ForwardRef as ReactComponent };